import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import MainMenu_Chats from "../../../../layout/menu/sections/chats/menu-chats";
import Navigation_ButtonChats from "../../../../layout/navigation/buttons/chats";
import Chat from "../../chat/chat/chat";


export class SpaceChats extends SpaceProto {

    constructor() {
        super(NavigationSectionType.CHATS)
        this.positionOptions = []

        this.title = "Chats"
    }

    get enabled():boolean {
        return gd.ac.components.hasAccess('chat')
    }

    get navigationStructureConfig() {
        return {
            id                  : this.id,
            name                : "Chats",
            icon                : "i5-nav-chat",
            hint                : "Chats & Discussions",
            keyboardShortcut    : 'C',
            type                : NavigationSectionType.CHATS,
            menuComponent       : MainMenu_Chats,
            renderComponent     : Navigation_ButtonChats,
            position            : NavigationButtonPosition.BOTTOM
        }

    }

    search(keyword: string): Chat[] {
        return gd.session.chats.search(keyword)
    }

}
